export default "__VITE_ASSET__GfIc211m__"